import { render, staticRenderFns } from "./UserInputs.vue?vue&type=template&id=4d98acd0&"
import script from "./UserInputs.vue?vue&type=script&lang=js&"
export * from "./UserInputs.vue?vue&type=script&lang=js&"
import style0 from "./UserInputs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports